// It looks like nv is defined when nvd3 is imported, but leave this alone.
/* eslint-disable no-undef */
let Bar_Chart;

let d3;
let nvd3;

// d3 = require("d3");

// nvd3 = require("nvd3");

Bar_Chart = (() => {
    Bar_Chart.prototype.graph = void 0;

    Bar_Chart.prototype.remove = function() {
        Promise.all([
            import(/* webpackChunkName: "nvd3" */ "d3"),
            import(/* webpackChunkName: "nvd3" */ "nvd3")
        ]).then(([module_d3, module_nvd3]) => {
            d3 = module_d3.default;
            nvd3 = module_nvd3.default;
            return d3.selectAll(`${this.graph} > *`).remove();
        });
    };

    Bar_Chart.prototype.render = function(data, format) {
        Promise.all([
            import(/* webpackChunkName: "nvd3" */ "d3"),
            import(/* webpackChunkName: "nvd3" */ "nvd3")
        ]).then(([module_d3, module_nvd3]) => {
            d3 = module_d3.default;
            nvd3 = module_nvd3.default;
            let graph;
            graph = this.graph;
            this.remove();
            return nv.addGraph(() => {
                let chart;
                chart = nv.models
                    .discreteBarChart()
                    .x(d => d[0])
                    .y(d => d[1])
                    .staggerLabels(false)
                    .tooltips(true)
                    .showValues(false)
                    .showYAxis(false)
                    .transitionDuration(350)
                    .color(d3.scale.ordinal().range(["#4c4c4c"]));
                chart.xAxis
                    .showMaxMin(false)
                    .tickFormat(d => d3.time.format(format)(new Date(d)));
                chart.tooltipContent((key, y, e, { series }) => {
                    data = series.values[y - 1];
                    return `<p>${e}</p>`;
                });
                chart.valueFormat(d3.format(".0f"));
                return d3
                    .select(graph)
                    .datum(data)
                    .transition()
                    .duration(500)
                    .call(chart);
            });
        });
    };

    function Bar_Chart(graph, data, format) {
        this.graph = graph;
        this.render(data, format);
    }

    return Bar_Chart;
})();

export default Bar_Chart;
